import i18next from "../../common/localization/i18n";

const SubscriptionType = [
  { value: null },
  { value: "email", text: i18next.t("NEW_SUBSCRIPTIONS_EDITOR.SUBSCRIPTIONS.EMAIL") },
  { value: "phone", text: i18next.t("NEW_SUBSCRIPTIONS_EDITOR.SUBSCRIPTIONS.SMS") },
];

export default SubscriptionType;
